<template>
  <div class="flex -mx-3">
    <div class="flex-1 px-3">
      {{ $t('name') | capitalize }}
    </div>
    <div class="w-48 px-3">
      {{ $t('objective') | capitalize }}
    </div>
    <div class="w-32 px-3">
      {{ $t('status') | capitalize }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataIteratHeader',
};
</script>
